import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['searchBtn']

  onFieldChange(event) {
    if (this.hasSearchBtnTarget) {
      this.updateSearchButtons(event.currentTarget)
    }
  }

  updateSearchButtons(field) {
    this.searchBtnTargets.forEach(btnTarget => {
      if (field.value == '') {
        btnTarget.classList.add('invisible')
      } else {
        let value = field.value

        if (btnTarget.getAttribute('data-searcher-url-type') == 'host') {
          try { value = new URL(field.value).hostname }
          catch (error) { }
        }

        btnTarget.href = btnTarget.getAttribute('data-searcher-url').replace('%{VALUE}', value)
        btnTarget.classList.remove('invisible')
      }
    })
  }
}
